<template>
    <div :class="['flex align-items-center ui-notification', notification[type]]">
        <div class="flex items-center">
            <SvgIcon class="w-16 h-16 mr-10" :type="type" fill="currentColor"></SvgIcon>
        </div>
        <div class="flex items-center">
            <p v-html="message"></p>
        </div>
    </div>
</template>
<script>

import SvgIcon from "../ui/SvgIcon.vue";

export default {
    components: {
        SvgIcon
    },
    props: {
        type: {
            type: String,
            default: 'info',
            validator: value => [
                'info',
                'warning',
                'success',
                'danger',
            ].includes(value),
        },
        message: {
            type: String,
            required: true,
            default: '',
        }
    },
    data() {
        return {
            notification: {
                info: 'notification-info',
                // Examples how this can be extended.
                // warning: 'notification-warning',
                // success: 'notification-success',
                // danger: 'notification-danger',
            }
        }
    }
}
</script>
<style>
    .ui-notification {
        background-color:#D9F6FF;
        border-left: 2px solid #086D8E;
        height: 70px;
        padding: 10px;
    }
    .ui-notification.notification-info {
        background-color: #D9F6FF;
    }
</style>